export const messages = {
  en: {
    marketGoodsItem: {
      search: {
        title: 'Search Conditions',
        prodName: 'Please enter product name'
      },
      list: {
        title: 'Marketing Products'
      },
      table: {
        picUrl: 'Image',
        prodName: 'Product Name',
        prodDesc: 'Product Description',
        picLink: 'Access URL',
        price: 'Price',
        shopName: 'Shop Name',
        sort: 'Sort'
      },
      fetchError: 'Failed to get marketing products'
    }
  },
  zh: {
    marketGoodsItem: {
      search: {
        title: '查询条件',
        prodName: '请输入商品名称'
      },
      list: {
        title: '营销商品'
      },
      table: {
        picUrl: '图片',
        prodName: '商品名称',
        prodDesc: '商品简介',
        picLink: '访问地址',
        price: '金额',
        shopName: '商铺名称',
        sort: '排序'
      },
fetchError: '获取营销商品失败'
    }
  },
  'zh-TW': {
    marketGoodsItem: {
      search: {
        title: '查詢條件',
        prodName: '請輸入商品名稱'
      },
      list: {
        title: '營銷商品'
      },
      table: {
        picUrl: '圖片',
        prodName: '商品名稱',
        prodDesc: '商品名稱',
        picLink: '訪問地址',
        price: '金額',
        shopName: '商鋪名稱',
        sort: '排序'
      },
      fetchError: '獲取營銷商品失敗'
    }
  }
}